<ng-template let-resourceAttendee #temp>
  @if (configService.isRestrictedResourceVisible(resourceAttendee.resource)) {
    <div class="row">
      <div class="col col-12 col-md-6 col-locations">
        <h3 class="room-name">
          <strong>{{
            (resourceAttendee.resource.displayNameForApp | localizedString) ??
              (resourceAttendee.resource.displayName | localizedString)
          }}</strong>
        </h3>
        <div class="location-buttons mb-2">
          @if (resourceAttendee.resource.navigationEnabled) {
            <cue-open-in-navigation-button
              [resourceId]="resourceAttendee.resource.idForFiltering"
              [enabled]="configService.value.navigationAppEnabled"
              [navigationAppUrl]="configService.value.navigationAppUrl"
            />
          }
          <button
            class="favourite-button"
            (click)="toggleFavourite(resourceAttendee.resource.id, resourceAttendee.isFavourite)"
            type="button"
          >
            <cue-icon
              [icon]="resourceAttendee.isFavourite ? ICONS.cueStarFill : ICONS.cueStar"
              class="favourite-icon"
            />
            <span class="text">
              {{
                resourceAttendee.isFavourite
                  ? (translation.reservationPopup.removeFromFavourites | transloco)
                  : (translation.reservationPopup.addToFavourite | transloco)
              }}
            </span>
          </button>
        </div>

        <div>
          @if (configService.value.infoSettings.descriptionVisible) {
            <p
              class="descriptionText room-description"
              [innerHTML]="resourceAttendee.resource.description | localizedString | cueCustomUnsafeSanitize"
            ></p>
          }
          <div class="popup-table">
            @if (
              (resourceAttendee.resource.displayNameForApp | localizedString) != null &&
              (resourceAttendee.resource.displayNameForApp | localizedString) !==
                (resourceAttendee.resource.displayName | localizedString)
            ) {
              <div class="popup-table-header">{{ translation.resource.alternativeName | transloco }}</div>
              <div class="popup-table-cell">{{ resourceAttendee.resource.displayName | localizedString }}</div>
            }
            <div class="popup-table-header">{{ translation.leftMenu.type | transloco }}</div>
            <div class="popup-table-cell">
              {{ configService.getResourceTypeFromId(resourceAttendee.resource.resourceTypeId).name | localizedString }}
            </div>
            @if (configService.getResourceTypeFromId(resourceAttendee.resource.resourceTypeId).capacityVisible) {
              <div class="popup-table-header">{{ translation.resourceDetail.capacity | transloco }}</div>
              <div class="popup-table-cell">
                {{
                  resourceAttendee.resource.capacity
                    ? resourceAttendee.resource.capacity
                    : (translation.common.unlimited | transloco)
                }}
              </div>
            }
            @if (configService.isRestrictedResourceVisible(resourceAttendee.resource)) {
              @for (
                simpleFilter of configService.getSimpleFiltersByResourceTypeId(
                  resourceAttendee.resource,
                  translocoService
                );
                track simpleFilter
              ) {
                @if (simpleFilter.value !== undefined && simpleFilter.value !== null && simpleFilter.value !== '') {
                  <div class="popup-table-header">{{ simpleFilter.name | localizedString }}</div>
                  <div class="popup-table-cell">
                    @if (simpleFilter.value === true) {
                      <cue-icon [icon]="ICONS.cueCheck" class="correct" />
                    }

                    @if (simpleFilter.value === false) {
                      <cue-icon [icon]="ICONS.cueClose" class="incorrect" />
                    }

                    @if (simpleFilter.value !== true && simpleFilter.value !== false) {
                      <div [innerHTML]="simpleFilter.value | localizedString | cueCustomUnsafeSanitize"></div>
                    }
                  </div>
                }
              }
            }
          </div>

          @if (configService.isRestrictedResourceVisible(resourceAttendee.resource)) {
            @for (
              enumerableFilter of configService.getEnumerableFiltersByResourceTypeId(resourceAttendee.resource);
              track enumerableFilter
            ) {
              @if (enumerableFilter.visible) {
                <ul class="room-properties">
                  <div class="item-label">
                    {{ enumerableFilter.name | localizedString }}
                  </div>
                  @for (value of enumerableFilter.value; track value) {
                    <li>
                      <div class="img-wrapper">
                        <img
                          [class.!object-cover]="value.imagePreferCover"
                          [ngStyle]="{ 'object-position': value.imageObjectPosition }"
                          [src]="value.imageUrl | imageWidth: 50"
                        />
                      </div>
                      <span class="descriptionText">
                        {{ value.title | localizedString }}
                      </span>
                    </li>
                  }
                </ul>
              }
            }
          }

          @if (resourceAttendee?.serverDetail?.qrCodes | poisCanBeShownInResource; as poisForResourceDetailList) {
            @if (poisForResourceDetailList.length > 0) {
              <div class="pois-wrapper">
                <h3 class="title">{{ translation.navigation.pois | transloco }}</h3>
                @for (poi of poisForResourceDetailList; track poi.qrCodeId) {
                  @let item = qrDetails[poi.qrCodeId];

                  @if (item()?.objects?.length > 0) {
                    <kendo-expansionpanel class="show-panel">
                      <ng-template kendoExpansionPanelTitleDirective>
                        <cue-poi [poi]="poi" link="false" />
                      </ng-template>

                      @if (item() && item().objects?.length > 0) {
                        <cue-controllable-objects
                          [qrCodeListOfResource]="item()?.qrCodes | qrIdList"
                          [objectList]="item().objects"
                          [qrCodeId]="item().qrCodeId"
                        />
                      }
                    </kendo-expansionpanel>
                  } @else {
                    <cue-poi [poi]="poi" link="false" />
                  }
                }
              </div>
            }
          }

          <cue-working-hours [relativeNow]="eventStart()" [workingHourInfo]="resourceAttendee.resource" />

          @if (resourceAttendee?.serverDetail && resourceAttendee.serverDetail.objects?.length > 0) {
            <cue-controllable-objects
              [qrCodeListOfResource]="resourceAttendee?.serverDetail?.qrCodes | qrIdList"
              [objectList]="resourceAttendee.serverDetail.objects"
              [qrCodeId]="resourceAttendee.serverDetail.qrCodeId"
            />
          }
        </div>
      </div>

      <div class="col col-12 col-md-6 col-gal-map">
        <div class="row mb-2">
          <div class="col-md-12" style="text-align: center">
            <cue-file-gallery [files]="resourceAttendee.resource.files" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            @if (resourceAttendee.breadcrumb) {
              <div class="breadcrumb-container">
                @for (item of resourceAttendee.breadcrumb; track item; let i = $index) {
                  <span class="breadcrumb">
                    @if (i !== 0) {
                      <cue-icon [icon]="ICONS.cueArrowRight" />
                    }
                    <span class="part">{{ item.name }}</span>
                  </span>
                }
              </div>
            }
            <assist-new-resource-map
              [areaId]="resourceAttendee.resource.mapInfos[0]!.areaId"
              [imageSrc]="resourceAttendee.mapFile"
              [resourceId]="resourceAttendee.resource.idForFiltering"
            />
          </div>
        </div>
      </div>
    </div>
  } @else {
    {{ resourceAttendee.resource | resourceTitle }} ( {{ translation.reservationPopup.other | transloco }})
  }
</ng-template>

<div class="room-detail">
  @if (data().length > 1) {
    @for (resourceAttendee of data(); track $index) {
      <kendo-expansionpanel
        class="show-panel"
        expandIcon="k-icon k-font-icon k-i-plus"
        collapseIcon="fa fa-minus"
        [title]="resourceAttendee.resource | resourceTitle"
      >
        <ng-template
          [ngTemplateOutlet]="temp"
          [ngTemplateOutletContext]="{
            $implicit: resourceAttendee,
          }"
        />
      </kendo-expansionpanel>
    }
  } @else {
    <ng-template
      [ngTemplateOutlet]="temp"
      [ngTemplateOutletContext]="{
        $implicit: data()[0],
      }"
    />
  }
</div>
